import axios from "axios";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostSshKeyRotationGenerateRequestSchema,
  TPostSshKeyRotationGenerateResponseSchema,
} from "./postSshKeyRotationGenerate.schema";

/** federation-sdk `buildHandler` failures use `errors: [{ message }]`, not top-level `message`. */
const messageFromLaForgeFailureBody = (body: unknown): string | undefined => {
  if (!body || typeof body !== "object") {
    return undefined;
  }
  const o = body as {
    message?: string;
    error?: string;
    errors?: readonly { message?: string }[];
  };
  const fromErrors = o.errors?.find(
    (e) => typeof e.message === "string" && e.message.trim()
  )?.message;
  if (fromErrors) {
    return fromErrors;
  }
  if (typeof o.message === "string" && o.message.trim()) {
    return o.message;
  }
  if (typeof o.error === "string" && o.error.trim()) {
    return o.error;
  }
  return undefined;
};

const extractErrorMessage = (err: unknown): string | undefined => {
  if (!axios.isAxiosError(err)) {
    return undefined;
  }
  const fromBody = messageFromLaForgeFailureBody(err.response?.data);
  if (fromBody) {
    return fromBody;
  }
  return err.message;
};

export const postSshKeyRotationGenerate = (axios: IAxiosInstance) => {
  return async (data: TPostSshKeyRotationGenerateRequestSchema) => {
    try {
      const response = await axios.noRetry.post<
        IApiResponse<TPostSshKeyRotationGenerateResponseSchema>
      >("/api/sshKeyRotations/generate", data);

      if (!response?.data?.success) {
        const msg =
          messageFromLaForgeFailureBody(response?.data) ??
          "Something went wrong";
        throw new Error(msg);
      }

      return response?.data?.data;
    } catch (err: unknown) {
      const apiMsg = extractErrorMessage(err);
      if (apiMsg) {
        throw new Error(apiMsg);
      }
      throw err;
    }
  };
};
